import { render, staticRenderFns } from "./MailTemplateForm.vue?vue&type=template&id=4fa4f764"
import script from "./MailTemplateForm.vue?vue&type=script&lang=js"
export * from "./MailTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./MailTemplateForm.vue?vue&type=style&index=0&id=4fa4f764&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports